import UserFeedbackIcon from './FeedbackIcon';

export default UserFeedbackIcon;
